import { useNavigate } from "@tanstack/react-router";
import { type FC, useCallback } from "react";
import AuthService from "@/src/application/services/auth-service";
import { useInject } from "@/src/presentation/hooks/useInject";

const LogoutButton: FC = () => {
  const authService = useInject<AuthService>(AuthService);
  const navigate = useNavigate();

  const logoutHandler = useCallback(async () => {
    authService.logout();
    navigate({ to: "/login" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authService.__currentVersion]);

  return (
    <button
      onClick={logoutHandler}
      className="text-brand-accent hover:text-brand-accent-hover text-sm font-medium hover:underline"
    >
      Logout
    </button>
  );
};

export default LogoutButton;
